export default __webpack_public_path__ + "static/media/mongo.9dc8ab5d.png";